import type { KRideProviderConfig } from '../mobility/KRideProvider'

function envFlag(value: string | undefined, defaultValue: boolean): boolean {
  if (value == null || value.trim() === '') return defaultValue
  return value.trim().toLowerCase() === 'true'
}

const krideConfig = {
  id: 'kride',
  displayName: 'K-RIDE',
  enabled: true,
  appStartUrl: 'https://service.kride.kakaomobility.com/3xb7d9',
  fallbackUrl: 'https://kride.kakaomobility.com/',
  supportsDestinationPrefill: false,
  campaignId: null,
  attributionId: null,
} as const satisfies KRideProviderConfig

export const providerConfig = {
  places: {
    endpoint: '/api/places',
    maxCandidates: 3,
  },
  routes: {
    endpoint: '/api/route',
  },
  mobility: {
    kride: krideConfig,
    uber: {
      baseUrl: 'https://m.uber.com/looking',
      clientId: import.meta.env.VITE_UBER_CLIENT_ID?.trim() ?? '',
    },
  },
  features: {
    // This repository is the Busan PoC build. Set false for a general commercial build.
    enableKRidePocSurvey: envFlag(import.meta.env.VITE_ENABLE_KRIDE_POC_SURVEY, true),
  },
} as const
